import axios from "axios";
import { backend_server_v3 } from "../utils/constants";

const api = axios.create({
  baseURL: backend_server_v3,
});

const authHeader = (token) =>
  token ? { Authorization: `Bearer ${token}` } : {};

export const authedGet = async (url, token) => {
  const response = await api.get(url, { headers: authHeader(token) });
  return response.data;
};

export const authedPut = async (url, data, token) => {
  const response = await api.put(url, data, {
    headers: authHeader(token),
  });
  return response.data;
};

export const authedPost = async (url, data, token) => {
  const response = await api.post(url, data, {
    headers: authHeader(token),
  });
  return response.data;
};

export const authedDelete = async (url, token) => {
  const response = await api.delete(url, {
    headers: authHeader(token),
  });
  return response.data;
};

export default api;
